import React from "react";
import { Modal } from "react-bootstrap";

import { translate } from "../IntlProviderWrapper";
import { classNames } from "@/lib/util";

import "./ConfirmationModal.scss";

export type ModalSizes = "sm" | "lg" | "xl";

type EventHandler = (event?: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;

export type ConfirmationModalProps = {
    show: boolean;
    title?: string;
    size?: ModalSizes;
    animation?: boolean;
    class_name?: string;
    accept_label?: string;
    cancel_label?: string;
    dangerous?: boolean;
    children?: React.ReactNode;
    onAccept?: EventHandler;
    onCancel?: EventHandler;
    onClose?: EventHandler;
};

const ConfirmationModal = (props: ConfirmationModalProps) => {
    const {
        title,
        size,
        show,
        animation = false,
        class_name,
        accept_label,
        cancel_label,
        dangerous = false,
        children,
        onAccept,
        onCancel,
        onClose,
    } = props;
    const handleClose = onClose ?? onCancel;
    return (
        <Modal
            size={size}
            dialogClassName={class_name ?? ""}
            show={show}
            animation={animation}
            onHide={() => handleClose?.()}
        >
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
                {handleClose !== undefined && (
                    <button type="button" className="close" onClick={handleClose}>
                        <span aria-hidden="true">×</span>
                        <span className="sr-only">{translate("common.close", "Close")}</span>
                    </button>
                )}
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            {(onAccept !== undefined || onCancel !== undefined) && (
                <Modal.Footer>
                    {onCancel !== undefined && (
                        <button
                            className="btn btn-outline-secondary"
                            onClick={onCancel}
                            autoFocus={dangerous || onAccept === undefined}
                        >
                            {cancel_label !== undefined ? cancel_label : translate("common.no", "No")}
                        </button>
                    )}
                    {onAccept !== undefined && (
                        <button
                            className={classNames("btn", {
                                "btn-danger": dangerous,
                                "btn-primary": !dangerous,
                            })}
                            onClick={onAccept}
                            autoFocus={!dangerous}
                        >
                            {accept_label !== undefined ? accept_label : translate("common.yes", "Yes")}
                        </button>
                    )}
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default ConfirmationModal;
